module.exports = __webpack_public_path__ + "static/img/feature4.3414913c.jpg";